import Button from "@/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import useAuthStore from "@/store/authStore";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function OnboardingSuccessDialog() {
  const user = useAuthStore((state) => state.user);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(
    searchParams.get("onBoardingSuccess") === "true"
  );

  return (
    <Dialog
      open={isOpen}
      onOpenChange={() => {
        setIsOpen(false);
        navigate("/dashboard");
      }}
    >
      <DialogContent className="sm:max-w-xl bg-white p-10">
        <DialogHeader>
          <DialogTitle className="text-2xl text-center">
            Welcome to Mediabridge, {user.first_name}!
          </DialogTitle>
          <DialogDescription className="text-center mt-4">
            This is your Campaign Dashboard - where most of the magic happens.
            Here you will see an overview of all of your campaigns in one
            convenient location. But before we get into the nitty gritty
            details, why don't we invite some others to join us. After all there
            is no I in team.
            <div className="flex justify-center mt-8">
              <Button
                type="secondary"
                onClick={() => {
                  navigate("/people");
                }}
              >
                Invite People to my Team
              </Button>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
